import { Component, Input, Output, SimpleChanges, ViewChild, Inject, EventEmitter, DOCUMENT } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular/ui/data-grid';
import { DxDateBoxComponent } from 'devextreme-angular/ui/date-box';
import { DxNumberBoxComponent } from 'devextreme-angular/ui/number-box';
import { environment } from '../../../../../environments/environment';

import { GenericService } from '../../../../../common/common.service';
import { PeriodDetail, MaxLimitAllocation, } from '../../CounterpartyLimits/CounterpartyLimits.component.model';
import { ConsoleLoggerService } from '../../../../../common/LoggerService/console-logger.service';
import { retry } from 'rxjs/operators';
import { Dates } from '../../../../../limit-management/limit-management-common.component';
import { ConfirmationComponent, ConfirmationType } from '../../../../../common/Controls/Confirmation/confirmation.component';
import { Constants } from '../../../../../common/constants';
import { UtilityService } from '../../../../../common/utility.service';


@Component({
    selector: 'app-LimitSideBar-Tab',
    templateUrl: './LimitSideBar.component.html',
  styleUrls: ['./LimitSideBar.component.css'],
    standalone: false
})
export class LimitSideBarComponent {
  @Input() __bIsLoadedFromDataSearch: boolean;//CRD-376-Pawan Prajapati
  @Input() __bSideBar: boolean;
  @Input() __oSideBarCounterPartyLimit: any;
  @Input() __dtMinDate: Date = new Date();
  @Input() __dtMaxDate: Date = new Date();
  @Output() getSideBarChange = new EventEmitter<boolean>();
  @Output() returnSidebarChanges = new EventEmitter<any>();
  public __oSystemSettings: any[] = [];
  public __sTradingCounterparty: string;
  public __oPeriodDetails: PeriodDetail[] = [];
  public __dMaxStartDate: Date;
  public __bWarningVisible: boolean = false;
  public __bAddPeriodDisabled: boolean = false;
  public __oMaxLimitDetails: any[] = [];
  public __oCalendarOptions: any = {};
  public __sDateFormat: string;
  public __sZoomLevel: string;
  @ViewChild("dpStartTime") dpStartTime: DxDateBoxComponent;
  @ViewChild("dpEndTime") dpEndTime: DxDateBoxComponent;
  @ViewChild(ConfirmationComponent) __oConfirmationComponent: ConfirmationComponent;


  constructor(@Inject(DOCUMENT) private document: any, public service: GenericService, private Logger: ConsoleLoggerService, public __oUtilityService: UtilityService) {
    let self = this;
  }
  ngOnInit() {
    this.__dtMinDate = this.handleDates(new Date(this.__dtMinDate), 1);
    this.__oCalendarOptions = {
      zoomLevel: 'year',
      maxZoomLevel: 'year',
      minZoomLevel: 'decade'
    }
  }
  ngOnChanges(changes: SimpleChanges) {
    try {
      let oPeriodDetail: PeriodDetail = new PeriodDetail();
      oPeriodDetail.PeriodName = "Period 1";
      this.__oSideBarCounterPartyLimit.IsTempLimit ? this.__dtMaxDate = this.__oSideBarCounterPartyLimit.To : "";
      if (this.__oSideBarCounterPartyLimit) {
        oPeriodDetail.StartDate = this.handleDates(this.__oSideBarCounterPartyLimit.DefaultDate, 2);
        oPeriodDetail.MaxStartDate = new Date(this.__dtMaxDate);
        oPeriodDetail.MinStartDate = this.handleDates(this.__dtMinDate, 1);
        false ? this.__sDateFormat = "dd MMM yyyy" : this.__sDateFormat = "monthAndYear";
        false ? this.__sZoomLevel = "month" : this.__sZoomLevel = "year";
      }

      this.__oSystemSettings = JSON.parse(localStorage.getItem('SystemSettingData'));
      if (this.__oSystemSettings) {
        let dValuationDate: Date = new Date(this.__oSystemSettings[0].ValuationDate);
        oPeriodDetail.RollingFromPeriod = this.monthDiff(dValuationDate, oPeriodDetail.StartDate);

        oPeriodDetail.MinRollingFromPeriod = 0;//oPeriodDetail.RollingFromPeriod;
        oPeriodDetail.MaxRollingFromPeriod = this.__oSystemSettings[0].CounterpartyLimitMaxTenure
        oPeriodDetail.MinRollingToPeriod = oPeriodDetail.RollingFromPeriod;
        oPeriodDetail.MaxRollingToPeriod = this.__oSideBarCounterPartyLimit.IsTempLimit ? this.monthDiff(dValuationDate, new Date(this.__oSideBarCounterPartyLimit.To)) : this.__oSystemSettings[0].CounterpartyLimitMaxTenure;
        oPeriodDetail.RollingFromPeriodSuspendValueChagned = false;
        oPeriodDetail.RollingToPeriodSuspendValueChagned = false;
      }
      this.__oPeriodDetails.length === 0 ? this.__oPeriodDetails.push(oPeriodDetail) : null;
      if (this.__oSideBarCounterPartyLimit) {
        this.__sTradingCounterparty = this.__oSideBarCounterPartyLimit.TradingCounterpartyName;
        //this.__oSideBarCounterPartyLimit.IsTempLimit ? this.__sDateFormat = "dd MMM yyyy" : this.__sDateFormat = "monthAndYear";
        //this.__oSideBarCounterPartyLimit.IsTempLimit ? this.__sZoomLevel = "month" : this.__sZoomLevel = "year";
      }
    }
    catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while executing Limit Side Bar contructor.');
    }

  }

  private handleDates(date: Date, day: number) {
    if (date) {
      let dt;
      dt = this.__oUtilityService.toLocalISODate(new Date(date));
      date = dt;
    }
    return date;
  }
  calculatePeriodFromDate(sDate: any) {
    if (!sDate)
      return '';
    if (this.__oSideBarCounterPartyLimit.TenorTypeName != 'Rolling')
      return '';
    this.__oSystemSettings = JSON.parse(localStorage.getItem('SystemSettingData'));
    if (this.__oSystemSettings) {
      let dValuationDate: Date = new Date(this.__oSystemSettings[0].ValuationDate);
      let dDate: Date = new Date(sDate);
      return `${this.monthDiff(dValuationDate, dDate)}`;
    }
    return '';
  }
  //Add period button click event 
  btnAddPeriod_Click() {
    try {
      let oDates: Dates = new Dates();
      if (this.__oPeriodDetails) {
        if (this.__oPeriodDetails.length > 0) {
          let oPeriodDetail: PeriodDetail = new PeriodDetail();
          let iPeriod = this.__oPeriodDetails[this.__oPeriodDetails.length - 1].PeriodName.charAt(this.__oPeriodDetails[this.__oPeriodDetails.length - 1].PeriodName.length - 1);
          oPeriodDetail.PeriodName = "Period " + (parseInt(iPeriod) + 1).toString();
          let dtPreviousMonthEndDate = new Date(this.__oPeriodDetails[this.__oPeriodDetails.length - 1].EndDate);
          let dtStartDate: Date = true ? new Date(dtPreviousMonthEndDate.setMonth(dtPreviousMonthEndDate.getMonth() + 1)) : oDates.dateAdd(new Date(dtPreviousMonthEndDate), 1, "days");

          //let dtStartDate: Date = new Date(this.__oPeriodDetails[this.__oPeriodDetails.length - 1].EndDate.setMonth(this.__oPeriodDetails[this.__oPeriodDetails.length - 1].EndDate.getMonth() + 1));
          oPeriodDetail.StartDate = dtStartDate;
          oPeriodDetail.MaxStartDate = new Date(this.__dtMaxDate);
          oPeriodDetail.MinStartDate = true ? this.handleDates(dtStartDate, 1) : dtStartDate;
          oPeriodDetail.Color = "black";
          oPeriodDetail.IsColorChanged = false;
          oPeriodDetail.LimitValue = null;

          this.__oSystemSettings = JSON.parse(localStorage.getItem('SystemSettingData'));
          if (this.__oSystemSettings) {
            let dValuationDate: Date = new Date(this.__oSystemSettings[0].ValuationDate);
            oPeriodDetail.RollingFromPeriod = this.monthDiff(dValuationDate, oPeriodDetail.StartDate);

            oPeriodDetail.MinRollingFromPeriod = oPeriodDetail.RollingFromPeriod;
            oPeriodDetail.MaxRollingFromPeriod = this.__oSystemSettings[0].CounterpartyLimitMaxTenure
            oPeriodDetail.MinRollingToPeriod = oPeriodDetail.RollingFromPeriod;
            oPeriodDetail.MaxRollingToPeriod = this.__oSystemSettings[0].CounterpartyLimitMaxTenure;
          }

          this.__oPeriodDetails.push(oPeriodDetail);
        }
        else {
          let oPeriodDetail: PeriodDetail = new PeriodDetail();
          oPeriodDetail.PeriodName = "Period 1";
          if (this.__oSideBarCounterPartyLimit) {
            oPeriodDetail.StartDate = this.handleDates(this.__oSideBarCounterPartyLimit.DefaultDate, 2);
            oPeriodDetail.MaxStartDate = new Date(this.__dtMaxDate);
            oPeriodDetail.MinStartDate = this.handleDates(this.__dtMinDate, 1);

            oPeriodDetail.RollingFromPeriod = 0;
            oPeriodDetail.MinRollingFromPeriod = oPeriodDetail.RollingFromPeriod;
            oPeriodDetail.MaxRollingFromPeriod = this.__oSystemSettings[0].CounterpartyLimitMaxTenure
            oPeriodDetail.MinRollingToPeriod = oPeriodDetail.RollingFromPeriod;
            oPeriodDetail.MaxRollingToPeriod = this.__oSystemSettings[0].CounterpartyLimitMaxTenure;
          }
          oPeriodDetail.Color = "black";
          oPeriodDetail.IsColorChanged = false;
          oPeriodDetail.LimitValue = null;
          this.__oPeriodDetails.push(oPeriodDetail);
        }
      }
    }
    catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while executing Add button click event.');
    }



  }
  //Delete Period button click event 
  btnDelete_Click(e: any, sPeriodName: string) {
    try {
      this.__oConfirmationComponent.show(ConfirmationType.Information, "Are you sure you want to delete " + sPeriodName + " ?", "Confirmation", "Yes", "No").then((result) => {
        if (!result) {
          return;
        }
        else {
          this.__oPeriodDetails.splice(this.__oPeriodDetails.indexOf(this.__oPeriodDetails.find(X => X.PeriodName == sPeriodName)), 1);
          this.getDisableStatus();
        }
      });

    }
    catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while executing Add button click event.');
    }

  }

  //Apply button click event 
  btnApply_Click() {
    if (this.__oPeriodDetails.filter(x => (x.LimitValue !== 0 && !x.LimitValue)) && this.__oPeriodDetails.filter(x => (x.LimitValue !== 0 && !x.LimitValue)).length > 0) {
      this.__oMaxLimitDetails = this.__oPeriodDetails.filter(x => (x.LimitValue !== 0 && !x.LimitValue));

      this.__oMaxLimitDetails.forEach(x => {
        if (x.MaxLimitDetail) {
          x.StartMonthName = x.MaxLimitDetail[0].MonthName;
          x.EndMonthName = x.MaxLimitDetail[x.MaxLimitDetail.length - 1].EndMonthName;
        }
      });

      this.__bWarningVisible = true;
    }
    else {
      this.returnSidebarChanges.emit(this.__oPeriodDetails);
    }
  }
  //Close button click event 
  btnClose_Click() {
    this.__bSideBar = false;
    this.getSideBarChange.emit(false);
  }
  //Disable or Enable add period button and apply button 
  getDisableStatus(): boolean {
    let bDisableStatus = false;
    this.__bAddPeriodDisabled = false;
    this.__oPeriodDetails.forEach(x => {
      if (!bDisableStatus && ((!x.StartDate || !x.EndDate) || (x.EndDate && (this.handleDates(new Date(x.EndDate), 2).getTime() === this.handleDates(new Date(this.__dtMaxDate), 2).getTime())))) {//|| !x.LimitValue
        bDisableStatus = true;
        this.__bAddPeriodDisabled = true;
      }
    });

    return bDisableStatus;
  }
  getApplyDisableStatus(): boolean {
    let bDisableStatus = false;
    this.__oPeriodDetails.forEach(x => {
      if (!bDisableStatus && (!x.StartDate || !x.EndDate)) {//|| !x.LimitValue
        bDisableStatus = true;
      }
    });

    return bDisableStatus;
  }
  //Text box key press event 
  onKeyPressNumberBox(e: any, ControlName: any, oSource: any) {
    try {
      const oInpElement = e.element.querySelector('.dx-texteditor-input') as HTMLInputElement;
      if (e.event.key.toString().toUpperCase() == "M" || e.event.key.toString().toUpperCase() == "B" || e.event.key.toString().toUpperCase() == "K" || e.event.key.toString().toUpperCase() == "H" || e.event.key.toString().toUpperCase() == "T" || e.event.key.toString().toUpperCase() == "Y" || (!e.event.target.value || e.event.target.value.toString() == "0")) {

        let oValue;
        let oMultiplier = 1;
        if (e.event.target.value.toString() == "0") {
          oValue = 0;
        }
        if (!e.event.target.value && e.event.target.value.toString() !== "0") {
          oValue = null;
          this.__oPeriodDetails.find(X => X.PeriodName == oSource.PeriodName).LimitValue = null;
        }
        else {
          oValue = parseFloat(e.event.target.value.toString().replace(",", "").replace(",", "").replace(",", "").replace(",", ""));
        }
        if (e.event.key.toString().toUpperCase() == "M") {
          oMultiplier = 1000000;
        }
        else if (e.event.key.toString().toUpperCase() == "B") {
          oMultiplier = 1000000000;
        }
        else if (e.event.key.toString().toUpperCase() == "K" || e.event.key.toString().toUpperCase() == "T") {
          oMultiplier = 1000;
        }
        else if (e.event.key.toString().toUpperCase() == "Y") {
          oMultiplier = 1000000000000;
        }
        if ((oValue && oMultiplier) || (oValue === 0)) {
          oValue = oValue * oMultiplier;
          switch (ControlName) {
            case 'nbLimit':
              this.__oPeriodDetails.find(X => X.PeriodName == oSource.PeriodName).LimitValue = oValue;
              break;
          }
        }
      }
     setTimeout(() => {
      oSource.LimitValue=parseFloat(e.event.target.value.toString().replace(",", "").replace(",", "").replace(",", "").replace(",", ""));
      this.onFocusOut(e,oSource); }, 30);
    }
    catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while executing numeric box key press event.');
    }




  }
  calculateLimitPeriodFromPeriod(oDataSource: any, sControlName: string, event: any) {
    oDataSource.MinRollingFromPeriod = this.calculatePeriodFromDate(oDataSource.MinStartDate);//oDataSource.MinRollingFromPeriod;

    if (!oDataSource.RollingToPeriod || oDataSource.RollingToPeriod == 0 || oDataSource.RollingToPeriod == '')
      oDataSource.MaxRollingFromPeriod = event.MaxRollingToPeriod;
    else
      oDataSource.MaxRollingFromPeriod = oDataSource.RollingToPeriod;

    oDataSource.MinRollingToPeriod = oDataSource.RollingFromPeriod;
    if (oDataSource) {
      if (oDataSource.RollingFromPeriodSuspendValueChagned) {
        oDataSource.RollingFromPeriodSuspendValueChagned = false;
        return;
      }
      if (oDataSource.RollingToPeriodSuspendValueChagned) {
        oDataSource.RollingToPeriodSuspendValueChagned = false;
        return;
      }
      switch (sControlName) {
        case 'dpStartTime':
          if (oDataSource.RollingFromPeriod < oDataSource.MinRollingFromPeriod || oDataSource.RollingFromPeriod > oDataSource.MaxRollingFromPeriod) {
            let msg = `The period must be higher than ${oDataSource.MinRollingFromPeriod} and lower than ${oDataSource.MaxRollingFromPeriod}.`;
            this.__oConfirmationComponent.show(ConfirmationType.Error, msg, "Error", "Ok", "", false);
            oDataSource.RollingFromPeriodSuspendValueChagned = true;
            event.component.option('value', event.previousValue);
            return;
          }
          break;
        case 'dpEndTime':
          if (oDataSource.RollingToPeriod < oDataSource.MinRollingToPeriod || oDataSource.RollingToPeriod > oDataSource.MaxRollingToPeriod) {
            let msg = `The period must be higher than ${oDataSource.MinRollingToPeriod} and lower than ${oDataSource.MaxRollingToPeriod}.`;
            this.__oConfirmationComponent.show(ConfirmationType.Error, msg, "Error", "Ok", "", false);
            oDataSource.RollingToPeriodSuspendValueChagned = true;
            event.component.option('value', event.previousValue);
            return;
          }
          break;
      }
      let dValuationDate: Date = null;
      this.__oSystemSettings = JSON.parse(localStorage.getItem('SystemSettingData'));
      if (this.__oSystemSettings) {
        dValuationDate = new Date(this.__oSystemSettings[0].ValuationDate);
        event.MaxRollingToPeriod = this.__oSystemSettings[0].CounterpartyLimitMaxTenure;
      }


      let dDates: Dates = new Dates();
      switch (sControlName) {
        case 'dpStartTime':     
            //CRD-1125 Right panel From date issue
          let dtFromDate = dDates.dateAdd(new Date(this.__oSystemSettings[0].ValuationDate), oDataSource.RollingFromPeriod, "months");        
          oDataSource.StartDate = dtFromDate;
          this.date_ValueChanged(oDataSource, sControlName, event);
          break;
        case 'dpEndTime':      
          //CRD-1125 Right panel TO date issue
          let dtToDate = dDates.dateAdd(new Date(this.__oSystemSettings[0].ValuationDate), oDataSource.RollingToPeriod, "months");               
          oDataSource.EndDate = dtToDate;
          this.date_ValueChanged(oDataSource, sControlName, event);
          break;
      }
    }
  }
  //date value changed event
  date_ValueChanged(oDataSource: any, sControlName: string, event: any, name?: any) {
    if(name) {
      oDataSource[name] = event.value;
    }
    oDataSource.Color = "black";
    oDataSource.IsColorChanged = false;
    try {
      this.dpEndTime["dateBox"].instance.option("isValid", true);
      this.dpStartTime["dateBox"].instance.option("isValid", true);
    }
    catch {
      console.log("Date picker component instance is undefined.");
    }
    switch (sControlName) {
      case 'dpEndTime':
        this.UpdateMaxLimitMessage(oDataSource, event);
        event.value = this.handleDates(new Date(event.value), 2);
        this.__bAddPeriodDisabled = (this.monthDiff(this.handleDates(new Date(event.value), 2), this.handleDates(new Date(this.__dtMaxDate), 2)) === 0) ? true : false;
        oDataSource.MaxStartDate = this.handleDates(new Date(event.value), 2);
        break;
      case 'dpStartTime':
        this.UpdateMaxLimitMessage(oDataSource, event);
        event.value = this.handleDates(new Date(event.value), 1);
        oDataSource.MaxStartDate = this.handleDates(oDataSource.EndDate, 2);
        break;
    }

  }
  //Funtion to update Limit Breach alert on side bar
  UpdateMaxLimitMessage(oDataSource: any, event: any) {
    try {
      let oPeriodDetail: PeriodDetail = new PeriodDetail();
      let __oMaxLimitAllocations: MaxLimitAllocation[] = [];
      let __oMaxLimitAllocationsDistict: MaxLimitAllocation[] = [];

      Object.assign(oPeriodDetail, oDataSource)
      oPeriodDetail = oDataSource;
      if (oPeriodDetail) {
        oPeriodDetail.MaxLimitDetail = [];
        if (oPeriodDetail.StartDate && oPeriodDetail.EndDate) {
          let arrMonthNames = [];

          let iStartColumIndex = this.monthDiff(new Date(this.__dtMinDate), new Date(oPeriodDetail.StartDate));//CRD-420-Pawan Prajapati
          let iEndColumnIndex = this.monthDiff(new Date(this.__dtMinDate), new Date(oPeriodDetail.EndDate));//CRD-420-Pawan Prajapati

          for (let i = 0; i < iStartColumIndex; i++) {
            __oMaxLimitAllocations.push(new MaxLimitAllocation());
          }

          arrMonthNames = this.GetMonthsBetweenDates(oPeriodDetail.StartDate, oPeriodDetail.EndDate)
          for (let i = 0; i < arrMonthNames.length; i++) {
            let oMaxLimitAllocation: MaxLimitAllocation = new MaxLimitAllocation();
            oMaxLimitAllocation.MonthName = arrMonthNames[i];
            oMaxLimitAllocation.EndMonthName = arrMonthNames[i];
            oMaxLimitAllocation.MaxLimitAllocation = 0;
            __oMaxLimitAllocations.push(oMaxLimitAllocation);
          }


          for (let i = iStartColumIndex; i <= iEndColumnIndex; i++) {
            __oMaxLimitAllocations[i].MaxLimitAllocation = this.__oSideBarCounterPartyLimit.DataValues[i].MaxAllocation;
          }
          let iStartIndex = 0
          let iPrevAllocation: Number = .000001;

          for (let i = iStartColumIndex; i < __oMaxLimitAllocations.length; i++) {
            if (__oMaxLimitAllocations[i].MaxLimitAllocation || __oMaxLimitAllocations[i].MaxLimitAllocation === 0) {// Limit values can be zero to show max limit
              if (__oMaxLimitAllocations[i].MaxLimitAllocation != iPrevAllocation) {
                __oMaxLimitAllocationsDistict.push(__oMaxLimitAllocations[i]);
                iStartIndex = i;
                iPrevAllocation = __oMaxLimitAllocations[i].MaxLimitAllocation;
              }
              else {
                let oMaxLimitAllocation: MaxLimitAllocation = __oMaxLimitAllocationsDistict.find(X => X.MonthName == __oMaxLimitAllocations[iStartIndex].MonthName);
                oMaxLimitAllocation.EndMonthName = __oMaxLimitAllocations[i].MonthName;
              }
            }
          }
          //for (let i = 0; i < __oMaxLimitAllocationsDistict.length; i++) {
          // sMaxLimitMsg.push(__oMaxLimitAllocationsDistict[i].MonthName + "-" + __oMaxLimitAllocationsDistict[i].EndMonthName + ":" + __oMaxLimitAllocationsDistict[i].MaxLimitAllocation.toString());
          //}
          //oPeriodDetail.MaxLimitDetail = sMaxLimitMsg;
          for (let i = 0; i < __oMaxLimitAllocationsDistict.length; i++) {
            let oMaxLimitMsg: any = {};
            oMaxLimitMsg.MonthName = __oMaxLimitAllocationsDistict[i].MonthName;
            oMaxLimitMsg.EndMonthName = __oMaxLimitAllocationsDistict[i].EndMonthName
            oMaxLimitMsg.MaxLimitAllocation = __oMaxLimitAllocationsDistict[i].MaxLimitAllocation < 0 ? 0 : __oMaxLimitAllocationsDistict[i].MaxLimitAllocation;
            oPeriodDetail.MaxLimitDetail.push(oMaxLimitMsg);
          }

          if (this.monthDiff(oPeriodDetail.EndDate, this.__dtMaxDate) !== 0) {
            let ioPeriodDetail = this.__oPeriodDetails.indexOf(oPeriodDetail);
            let dtPreviousMonthEndDate = new Date(this.__oPeriodDetails[ioPeriodDetail].EndDate);
            let dtStartDate: Date = new Date(dtPreviousMonthEndDate.setMonth(dtPreviousMonthEndDate.getMonth() + 1));
            (((this.__oPeriodDetails.length - 1) > ioPeriodDetail) && this.__oPeriodDetails[ioPeriodDetail + 1]) ? (this.__oPeriodDetails[ioPeriodDetail + 1].MinStartDate = dtStartDate, this.__oPeriodDetails[ioPeriodDetail + 1].MaxStartDate = new Date(this.__dtMaxDate)) : "";
          }
        }
        else {
          oPeriodDetail.MaxLimitDetail = [];
        }

      }
      //Start Siju FB 28114
      if (this.__oPeriodDetails.length > 1 && this.__oPeriodDetails.indexOf(oDataSource) < (this.__oPeriodDetails.length - 1)) {
        let sOverlappingPeriods: String[] = [];
        for (let i = this.__oPeriodDetails.indexOf(oDataSource) + 1; i < this.__oPeriodDetails.length; i++) {
          if (this.__oPeriodDetails[i].StartDate && oDataSource.EndDate && this.__oPeriodDetails[i].StartDate <= oDataSource.EndDate) {
            sOverlappingPeriods.push(this.__oPeriodDetails[i].PeriodName);
          }
        }
        if (sOverlappingPeriods.length > 0) {
          this.__oConfirmationComponent.show(ConfirmationType.Information, "The new end date of " + oDataSource.PeriodName + " is overlapping with the period(s) " + sOverlappingPeriods.join(", ") + ".<br />" + "If you continue with new end date, all these periods will be deleted.<br /> Are you sure you want to continue?", "Overlapping Periods", "Yes", "No").then((result) => {
            if (!result) {
              oDataSource.EndDate = event.previousValue;
              return;
            }
            else {
              sOverlappingPeriods.forEach(x => {
                this.__oPeriodDetails.splice(this.__oPeriodDetails.indexOf(this.__oPeriodDetails.find(y => y.PeriodName == x)), 1);
              });
            }
          });
        }
      }
      //End Siju FB 28114
      //if (this.__oPeriodDetails.indexOf(oDataSource) < this.__oPeriodDetails.length) {
      // this.__oPeriodDetails.splice(this.__oPeriodDetails.indexOf(oDataSource) + 1, (this.__oPeriodDetails.length - (this.__oPeriodDetails.indexOf(oDataSource))));
      //}
    }
    catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while updating maximum limit message.');
    }


  }
  //onValueChanged(event: any, oPeriodDetail: PeriodDetail) {
  //    oPeriodDetail.MaxLimitDetail.forEach(x => {
  //        if (x.MaxLimitAllocation < event.value) {
  //            oPeriodDetail.Color = "yellow";
  //        }
  //        //else {
  //        //    oPeriodDetail.Color = "black";
  //        //}
  //    })
  //}

  onFocusOut(event: any, oPeriodDetail: PeriodDetail) {
    let bFlagAllocation = 0;
    oPeriodDetail.MaxLimitDetail.forEach(x => {
      if (x.MaxLimitAllocation < oPeriodDetail.LimitValue && this.__oSideBarCounterPartyLimit.TradingCategoryName !== 'Overall' && !this.__oSideBarCounterPartyLimit.IsTempLimit) {
        bFlagAllocation = 1;
        oPeriodDetail.Color = "yellow";
        oPeriodDetail.IsColorChanged = true;
      }
    });

    if (oPeriodDetail.LimitValue !== null) {
      !isNaN(oPeriodDetail.LimitValue) ? oPeriodDetail.LimitValue = Math.abs(oPeriodDetail.LimitValue) : null;
    }
    bFlagAllocation === 1 ? oPeriodDetail.IsColorChanged = true : oPeriodDetail.IsColorChanged = false;
  }

  monthDiff(d1: Date, d2: Date) {
    try {
      let months;
      months = (d2.getFullYear() - d1.getFullYear()) * 12;
      months -= d1.getMonth();
      months += d2.getMonth();
      return months <= 0 ? 0 : months;
    }
    catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while executing month difference.');
    }

  }
  GetMonthsBetweenDates(d1: Date, d2: Date) {
    try {
      const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      const arr = [];
      const datFrom = new Date(d1);
      const datTo = new Date(d2);
      const fromYear = datFrom.getFullYear();
      const toYear = datTo.getFullYear();
      const diffYear = (12 * (toYear - fromYear)) + datTo.getMonth();
      for (let i = datFrom.getMonth(); i <= diffYear; i++) {
        arr.push(monthNames[i % 12] + " " + Math.floor(fromYear + (i / 12)));
      }
      return arr;
    }
    catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while finding months between date period.');
    }

  }
  ///Removes cell values on click
  btnRemoveAll_Click() {
    this.returnSidebarChanges.emit(this.__oPeriodDetails);
    this.__bWarningVisible = false;
  }
  //Cancels operation
  btnCancel_Click() {
    this.__bWarningVisible = false;
  }
  //stop writing
  stopWriting(e: any) {
    if (e.event.keyCode != 9) {
      e.event.preventDefault();
      e.event.stopPropagation();
    }
  }
}
